<template>
  <div v-if="parents && rule">
    <h1>Rule</h1>
    <v-btn :to="{ name: 'quoteRuleSet', params: { id: rule.rulesetid } }">
      <v-icon>chevron_left</v-icon>Rule set
    </v-btn>
    <div>
      <h2>Conditions</h2>
      <v-btn
        :to="{
          name: 'quoteConditionAdd',
          query: { ruleid: rule.id }
        }"
      >
        <v-icon>add</v-icon>Condition
      </v-btn>
      <v-data-table
        :pagination.sync="pagination"
        :headers="computedHeaders"
        :items="rule.conditions"
        class="elevation-1"
        v-if="rule.conditions"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-btn
                :to="{
                  name: 'quoteCondition',
                  params: {
                    id: props.item.id
                  }
                }"
                small
                >{{ props.item.id }}</v-btn
              >
            </td>
            <td>
              <ConditionDescription :condition="props.item" />
            </td>
            <td v-if="!parents.quoteScript.published">
              <v-btn @click="deleteCondition(props.item)" color="error" small>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <h2>Actions</h2>
      <v-btn
        :to="{
          name: 'quoteActionAdd',
          query: {
            ruleid: rule.id
          }
        }"
      >
        <v-icon>add</v-icon>Action
      </v-btn>
      <v-data-table
        :pagination.sync="pagination"
        :headers="computedHeaders"
        :items="rule.actions"
        class="elevation-1"
        v-if="rule.actions"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-btn
                :to="{
                  name: 'quoteAction',
                  params: {
                    id: props.item.id
                  }
                }"
                small
                >{{ props.item.id }}</v-btn
              >
            </td>
            <td>
              <ActionDescription :action="props.item" />
            </td>
            <td v-if="!parents.quoteScript.published">
              <v-btn @click="moveAction(props.item, true)" small>
                <v-icon>arrow_upward</v-icon>
              </v-btn>
              <v-btn @click="moveAction(props.item, false)" small>
                <v-icon>arrow_downward</v-icon>
              </v-btn>
              <v-btn @click="deleteAction(props.item)" color="error" small>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import ActionDescription from "@/components/quote/quoteScript/ActionDescription";
import ConditionDescription from "@/components/quote/quoteScript/ConditionDescription";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Rule",
  metaInfo() {
    return {
      title: "Rule",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { ActionDescription, ConditionDescription },
  computed: {
    computedHeaders() {
      if (!this.parents) {
        return undefined;
      }
      let headers = [
        {
          text: "Id",
          sortable: false
        },
        {
          text: "Description",
          sortable: false
        }
      ];
      if (!this.parents.quoteScript.published) {
        headers.push({
          text: " ",
          sortable: false
        });
      }
      return headers;
    }
  },
  data() {
    return {
      rule: null,
      parents: null,
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    async fetchRule() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rules/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.rule = response.data;
    },
    async fetchParents() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rules/${this.$route.params.id}/parents`
      );
      // console.log(response.data);
      this.parents = response.data;
    },
    async deleteCondition(condition) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/sales/conditions/${condition.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    async deleteAction(action) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/sales/actions/${action.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    async moveAction(action, up) {
      await nbmlaw.put(
        `/cors/admin/sales/rules/${this.$route.params.id}/actions/${action.id}/move`,
        null,
        { params: { up } }
      );
      // console.log(response.data);
      this.update();
    },
    update() {
      this.showForm = false;
      this.rule = null;
      this.parents = null;
      this.fetchRule();
      this.fetchParents();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    }
  }
};
</script>